// src/LanguageSwitcher.js
import React from 'react';
import { useTranslation } from 'react-i18next';
// Importez les composants des drapeaux que vous avez besoin
import { FR, GB, HT } from 'country-flag-icons/react/3x2';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // Fonction utilitaire pour le style des boutons
  const getButtonClass = (lng) => {
    return i18n.language === lng ? 'language-button active' : 'language-button';
  };

  return (
    <div className="language-selector">
      {/* Bouton Français (fr) */}
      <button 
        onClick={() => changeLanguage('fr')} 
        className={getButtonClass('fr')}
      >
        {/* Utilisation du composant de drapeau FR */}
        <FR title="Français" className="flag-icon" />
      </button>

      {/* Bouton Anglais (en) */}
      <button 
        onClick={() => changeLanguage('en')} 
        className={getButtonClass('en')}
      >
        {/* Utilisation du composant de drapeau GB (Anglais) */}
        <GB title="English" className="flag-icon" />
      </button>

      {/* Bouton Créole (ht) */}
      <button 
        onClick={() => changeLanguage('ht')} 
        className={getButtonClass('ht')}
      >
        {/* Utilisation du composant de drapeau HT */}
        <HT title="Kreyòl" className="flag-icon" />
      </button>
    </div>
  );
}

export default LanguageSwitcher;